<template>
    <el-dialog
        :visible.sync="showObj.login"
        :modal-append-to-body=false
        :show-close=false>
        <div class="modal-logo"><img src="../../../static/img/evhui-logo.png" alt="evhui"></div>
        <div class="social-login">
            <p class="section-title">社交账号登录</p>
            <div class="social-wrap">
                <div class="wechat" >
                    <a @click="turnToModal('qrcode')"><img src="../../../static/img/wechat.svg" alt="wechat"></a>
                </div>
                <div class="weibo">
                    <a href="/api/socialite/auth/weibo"><img src="../../../static/img/weibo.svg" alt="weibo"></a>
                </div>
                <div class="qq">
                    <a href="/api/socialite/auth/qq"><img src="../../../static/img/qq.svg" alt="qq"></a>
                </div>
            </div>
        </div>
        <div class="form login-form">
            <p class="section-title">或者</p>
            <div class="ipts">
                <input class="ipt ipt-username" type="text" @click="showWrongTip=false" v-model="username" placeholder="手机号/电子邮箱">
                <p class="wrong-tips" v-show="showWrongTip">账号或密码错误</p>
                <input class="ipt ipt-pwd" type="password" @click="showWrongTip=false" v-model="password" placeholder="密码">
            </div>
            <div class="btns">
                <input class="btn btn-solid" type="button" name="" value="登录" @click="login()">
                <input class="btn btn-hollow" type="button" name="" value="取消" @click="showObj.login = false">
            </div>
        </div>
        <div class="modal-footer">
            <a href="#" @click="turnToModal('changePwd')">忘记密码</a>
            <a href="#" @click="turnToModal('register')">新用户</a>
        </div>
        <div class="btn-close" @click="showObj.login = false"></div>
    </el-dialog>
</template>

<script>
// /api/socialite/auth/weixinweb
    import axios from 'axios'
    export default {
        props: ["showObj"],
        data() {
            return {
                username: null,
                password: null,
                showWrongTip: false
            };
        },
        methods: {
            turnToModal(param) {
                // 这里会闪一下，并且右边滑动条不会消失

                for(var modal in this.showObj) {
                    this.showObj[modal] = false;
                }
                this.showObj[param] = true;
            },
            cookie: function(type, c_name, value, expiredays) {
                if(type === 'set') {
                    var exdate=new Date()
                    exdate.setDate(exdate.getDate()+expiredays)
                    document.cookie=c_name+ "=" +escape(value)+
                    ((expiredays==null) ? "" : "; expires="+exdate.toGMTString())
                }else if(type === 'get') {
                    if (document.cookie.length > 0) {
                        var c_start = document.cookie.indexOf(c_name + "=")
                        if (c_start != -1) {
                            c_start = c_start + c_name.length + 1
                            var c_end = document.cookie.indexOf(";", c_start)
                            if (c_end == -1) c_end = document.cookie.length
                            return unescape(document.cookie.substring(c_start, c_end))
                        }
                    }
                    return;
                }
            },
            login() {
                var that = this;
                axios.post('/api/user/login', {
                    username: this.username,
                    password: this.password
                })
                .then(function (response) {
                    if(response.data.code === 0) {
                        that.cookie('set', 'jwt_token', response.data.data, 1);
                        that.turnToModal();
                        that.$emit('userLogin', 1)
                    }else {
                        that.showWrongTip = true;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    $maincolor: #0666b2;
    .modal-logo {
        margin: -20px auto 30px;
        img {
            display: block;
            margin: 0 auto;
        }
    }
    .section-title {
        position: relative;
        margin: 30px auto;
        width: 460px;
        font-size: 16px;
        text-align: center;
        &:before {
            content: "";
            position: absolute;
            top: 8px;
            right: 0;
            width: 160px;
            height: 1px;
            background-color: #999;
        }
        &:after {
            content: "";
            position: absolute;
            top: 8px;
            left: 0;
            width: 160px;
            height: 1px;
            background-color: #999;
        }
    }
    .social-wrap {
        display: flex;
        justify-content: space-between;
        width: 460px;
        margin: 0 auto;
        img {
            cursor: pointer;
        }
    }
    .wrong-tips {
        position: relative;
        padding-left: 22px;
        margin: -15px 60px 15px;
        font-size: 14px;
        color: #c33;
        &:before {
            content: "";
            position: absolute;
            top: -1px;
            left: 0;
            display: block;
            width: 16px;
            height: 16px;
            background-image: url("../../../static/img/wrong-tip.svg");
            background-size: 100%;
            background-repeat: no-repeat;
        }
    }
</style>



// WEBPACK FOOTER //
// Login.vue?a56c9d5e